import React, { useEffect, useState } from 'react';
import { Field, change } from 'redux-form';
import { Input, Select, Radio } from '../../../../form/';
import { CountriesStates } from '../../../../CountriesStates';

const FULFILLMENT_OPTIONS = [
  { value: 'office', label: 'Ship to Office' },
  { value: 'patient', label: 'Ship to Patient' },
  { value: 'others', label: 'Ship to Other' },
  { value: 'stock_inoffice', label: 'Stock / In-Office Trial' },
];

export default function ContactLensFulfillment({
  member,
  orderStatus,
  fulfillment,
  pprops,
  formName = 'orderContactLensForm',
  wrapperClasses = 'col-12 mt-4 mb-5',
}) {
  const savedCountry = fulfillment?.address?.country || '';
  const [selectedCountry, setSelectedCountry] = useState(savedCountry);
  const [fulfillmentType, setFulfillmentType] = useState(fulfillment?.type || 'office');
  const isDisabled = orderStatus === 'finalized';

  useEffect(() => {
    if (savedCountry) {
      setSelectedCountry(savedCountry);
    }
  }, [savedCountry]);

  useEffect(() => {
    setFulfillmentType(fulfillment?.type || 'office');
  }, [fulfillment?.type]);

  const handleFulfillmentChange = (_e, value) => {
    if (value) setFulfillmentType(value);
    setTimeout(() => pprops.submit(), 500);
  };

  const handleDispensingStatusChange = () => {
    setTimeout(() => pprops.submit(), 500);
  };

  const handleCountryChange = (value) => {
    setSelectedCountry(value || '');
    pprops.dispatch(change(formName, `${member}[fulfillment][address][state]`, ''));
    setTimeout(() => pprops.submit(), 500);
  };

  const handleAddressFieldBlur = () => {
    setTimeout(() => pprops.submit(), 500);
  };

  const handleStateChange = () => {
    setTimeout(() => pprops.submit(), 500);
  };

  const countryOptions = CountriesStates.map((c) => ({
    label: c.countryName,
    value: c.countryName,
  }));
  const countryData = CountriesStates.find((c) => c.countryName === selectedCountry);
  const stateOptions = countryData
    ? countryData.regions.map((r) => ({ label: r.name, value: r.shortCode || r.name }))
    : [];

  return (
    <div className={wrapperClasses}>
      <div className="row">
        <div className="col-lg-6 col-md-12 border-right">
          <h5 className="font-weight-bold mb-2">Fulfillment</h5>
          <p className="text-muted small mb-4">
            Select a shipping option. Details for the selected option are shown below.
          </p>

          <div
            className={`d-flex flex-wrap align-items-center mb-5 ${isDisabled ? 'disabled' : ''}`}
          >
            {FULFILLMENT_OPTIONS.map((option) => (
              <Field
                key={option.value}
                name={`${member}[fulfillment][type]`}
                value={option.value}
                type="radio"
                component={Radio}
                label={option.label}
                wrapperClasses="radio-sm mr-7 mb-3"
                disabled={isDisabled}
                onChange={handleFulfillmentChange}
              />
            ))}
          </div>
        </div>

        <div className="col-lg-6 col-md-12 pl-10">
          <h5 className="font-weight-bold mb-2">
            Trial Dispensing
          </h5>
            <p className="text-muted small">
              (Applicable to contact lens trial orders only)
            </p>
          <div
            className={`d-flex flex-wrap align-items-center mt-4 mb-5 ${isDisabled ? 'disabled' : ''}`}
          >
            <Field
              name={`${member}[dispensing_status]`}
              value="needs_dispensing_appointment"
              type="radio"
              component={Radio}
              label="Needs Dispensing Appointment"
              wrapperClasses="radio-sm mr-7 mb-3"
              disabled={isDisabled}
              onChange={handleDispensingStatusChange}
            />
            <Field
              name={`${member}[dispensing_status]`}
              value="ok_to_dispense"
              type="radio"
              component={Radio}
              label="OK to Dispense"
              wrapperClasses="radio-sm mb-3"
              disabled={isDisabled}
              onChange={handleDispensingStatusChange}
            />
          </div>
        </div>
      </div>

      <div className=" rounded p-5 border border-light">
        {fulfillmentType === 'office' && (
          <>
            <h6 className="font-weight-bold mb-1">Office Address</h6>
            <p className="text-muted mb-0 small">
              Uses the office/location associated with the order. No additional entry required.
            </p>
          </>
        )}

        {fulfillmentType === 'patient' && (
          <>
            <h6 className="font-weight-bold mb-1">Patient Demographic Address</h6>
            <p className="text-muted mb-0 small">
              Uses the patient's saved address. Required fields: Address 1, City, State, and ZIP.
            </p>
          </>
        )}

        {fulfillmentType === 'others' && (
          <>
            <h6 className="font-weight-bold mb-3">Other Address</h6>
            <p className="text-muted mb-4 small">
              Enter a one-time shipping address for this suborder. This does not update patient
              demographics.
            </p>
            <div className="row">
              <div className="col-md-4 mb-3">
                <Field
                  name={`${member}[fulfillment][address][address1]`}
                  component={Input}
                  label="Address 1"
                  className="form-control"
                  disabled={isDisabled}
                  onBlur={handleAddressFieldBlur}
                />
              </div>
              <div className="col-md-4 mb-3">
                <Field
                  name={`${member}[fulfillment][address][address2]`}
                  component={Input}
                  label="Address 2"
                  className="form-control"
                  disabled={isDisabled}
                  onBlur={handleAddressFieldBlur}
                />
              </div>
              <div className="col-md-4 mb-3">
                <Field
                  name={`${member}[fulfillment][address][city]`}
                  component={Input}
                  label="City"
                  className="form-control"
                  disabled={isDisabled}
                  onBlur={handleAddressFieldBlur}
                />
              </div>
              <div className="col-md-4 mb-3">
                <Field
                  name={`${member}[fulfillment][address][country]`}
                  component={Select}
                  label="Country"
                  className="form-control"
                  data={countryOptions}
                  textField="label"
                  valueField="value"
                  placeholder="Select"
                  onChange={(e, val) => handleCountryChange(val)}
                  disabled={isDisabled}
                />
              </div>
              {selectedCountry && (
                <div className="col-md-4 mb-3">
                  <Field
                    key={`${member}-state-${selectedCountry}`}
                    name={`${member}[fulfillment][address][state]`}
                    component={Select}
                    label="State"
                    className="form-control"
                    data={stateOptions}
                    textField="label"
                    valueField="value"
                    placeholder="Select"
                    disabled={isDisabled}
                    onChange={handleStateChange}
                  />
                </div>
              )}
              <div className="col-md-4 mb-3">
                <Field
                  name={`${member}[fulfillment][address][zip]`}
                  component={Input}
                  label="ZIP"
                  className="form-control"
                  disabled={isDisabled}
                  onBlur={handleAddressFieldBlur}
                />
              </div>
            </div>
          </>
        )}

        {fulfillmentType === 'stock_inoffice' && (
          <>
            <h6 className="font-weight-bold mb-1">Stock / In-Office Trial</h6>
            <p className="text-muted mb-0 small">
              No external vendor order is created. Inventory will be used for this trial lens.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
